import { ajax } from 'js/functions';

const cart_count_el = document.querySelector('.woo_header_buttons .cart_count .count');

export function add_to_cart_ajax_init(container = document){

    container.querySelectorAll('.add_to_cart_ajax').forEach(button=>{
        if( button.add_to_cart_ajax_init ) return;
        button.add_to_cart_ajax_init = 1;
        button.addEventListener('click', add_to_cart);
    })
}

function add_to_cart(e){
    
    const button = e.target;

    if( button.classList.contains('default') ) {
        // default functionality, link
        return;
    }

    e.preventDefault();

    const product_id = button.dataset.product_id;
    
    if( !product_id ) return;
    if( button.classList.contains('loading') ) return;
    if( button.classList.contains('not_available') ) return;

    button_init(button);
    loading(button);
    
    ajax('woo/add_to_cart', { product_id }, (res)=>{
        after_request(res, button);
    });
}

function loading(button){
    button.textContent = 'Adding...';
    button.classList.add('loading');
}

function button_init(button){
    if( typeof button.add_to_cart_init !== 'undefined' ) return;
    button.add_to_cart_init = true;
    button.initial_text = button.textContent;
    button.style.minWidth = button.offsetWidth+'px';
}

async function after_request(res, button){
    
    if( res.success ) {
        on_success(res, button);
    }
    else {
        on_fail(button);
    }

    button.classList.remove('loading');
}

function on_success(res, button){
    button.classList.add('default');
    button.textContent = 'View cart';
    update_cart_count(res.count);
    document.body.dispatchEvent(new Event('cart_item_add'));
}

function on_fail(button){
    button.classList.add('not_available');
    button.textContent = 'Not available';
}

function update_cart_count(count){
    if( !cart_count_el ) return;
    cart_count_el.textContent = count;
    cart_count_el.dataset.count = count;
}